import UserApi from "../api/service/user/UserApi";

export default class UserService {
    api;

    constructor() {
        this.api = new UserApi();
    }

    async getUserList({ page, pageSize, enabled, search }) {
        return this.api.getUserList({ page, pageSize, enabled, search }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getUserInfo() {
        return this.api.getUserInfo().then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async updateTargetUserInfo(reqDto) {
        return this.api.updateTargetUserInfo(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async putFranchiseUser(franchise_join_status) {
        return this.api.putFranchiseUser(franchise_join_status).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }
}
